import React from 'react';
import { FileText, ListChecks, AlertCircle, Lightbulb, MapPin, Users } from 'lucide-react';

export const DeliverablesSection = () => {
  const deliverables = [
    {
      icon: FileText,
      text: "Un diagnostic structuré des principaux écarts de perception"
    },
    {
      icon: ListChecks,
      text: "Une hiérarchisation des problèmes identifiés"
    },
    {
      icon: AlertCircle,
      text: "L'explication de leurs conséquences sur la compréhension ou la confiance"
    },
    {
      icon: Lightbulb,
      text: "Des orientations et exemples de corrections"
    },
    {
      icon: MapPin,
      text: "Un plan d'action indiquant quoi traiter, pourquoi et dans quel ordre"
    },
    {
      icon: Users,
      text: "Une restitution permettant de discuter des conclusions et des priorités"
    }
  ];

  return (
    <section id="livrables" className="py-32 bg-gray-50 relative">
      <div className="container-custom">
        <div className="max-w-5xl mx-auto fade-in-section">
          <h2 className="section-title mb-12 text-center">
            À la fin, vous ne recevez pas<br />
            seulement un <span className="text-accent">constat</span>.
          </h2>

          <div className="grid md:grid-cols-2 gap-6 mb-12">
            {deliverables.map((item, index) => (
              <div 
                key={index}
                className="flex items-start gap-4 p-6 bg-white rounded-lg border border-gray-200"
              >
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-accent/10 rounded-lg">
                  <item.icon className="h-5 w-5 text-accent" />
                </div>
                <p className="text-gray-700 leading-relaxed pt-1">
                  {item.text}
                </p>
              </div>
            ))}
          </div>

          <div className="p-8 bg-white border-l-4 border-accent rounded-lg">
            <p className="text-lg text-gray-900 leading-relaxed">
              <span className="font-semibold">Le diagnostic détermine les actions nécessaires.</span> Leur mise en œuvre peut ensuite être réalisée en interne ou confiée à Be Asset sur devis.
            </p>
          </div>

          <div className="mt-8 text-center">
            <p className="text-gray-600 italic">
              Le diagnostic n'est pas un document purement théorique. Il est conçu pour être actionnable.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DeliverablesSection;
